import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { BehaviorSubject } from 'rxjs';
import { CalamityModel} from './models/calamity.model';
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root',
})

export class CalamityService extends GenericService<CalamityModel> {
    private cal_IdSubject$ = new BehaviorSubject(null);
    public calId$ = this.cal_IdSubject$.asObservable();
    constructor(private http: HttpClient) {
        super(http,'/Calamity/', environment.Services.AlphaURLSlot1)
    }

    setCalId(calId:string) {
        this.cal_IdSubject$.next(calId);
    }
}